var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49449",
    "data-name": "Group 49449",
    transform: "translate(4996 -14158)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138312",
    "data-name": "Rectangle 138312",
    width: 24,
    height: 24,
    transform: "translate(-4996 14158)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49448",
    "data-name": "Group 49448",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93673",
    "data-name": "Path 93673",
    d: "M.75,8.73V7.75c0-5,2-7,7-7h6c5,0,7,2,7,7v6c0,5-2,7-7,7h-1",
    transform: "translate(-4995 14159)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93674",
    "data-name": "Path 93674",
    d: "M11.75,9.75l5.01-5.02H12.75",
    transform: "translate(-4995 14159)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_604",
    "data-name": "Line 604",
    y2: 4.01,
    transform: "translate(-4978.24 14163.73)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138311",
    "data-name": "Rectangle 138311",
    width: 9,
    height: 9,
    rx: 3,
    transform: "translate(-4994.25 14170.75)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrore);
export default __webpack_public_path__ + "static/media/scrore.6b81eb4a597a6a59dc5f6bb564e9f3db.svg";
export { ForwardRef as ReactComponent };